import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16 14V9c0-2.978-2.172-5.443-5.018-5.913.003-.03.018-.056.018-.087 0-.552-.448-1-1-1s-1 .448-1 1c0 .031.015.057.018.087C6.173 3.557 4 6.021 4 9v5H3v1h4c0 1.657 1.343 3 3 3s3-1.343 3-3h4v-1h-1zM5 9c0-2.757 2.243-5 5-5s5 2.243 5 5v2H5V9zm5 8c-1.103 0-2-.897-2-2h4c0 1.103-.897 2-2 2zm-5-3v-2h10v2H5z',
  ],
  height: 20,
  width: 20,
});
